// PWA Installation Helper with Auto-Update Support
export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('✅ Service Worker registered:', registration.scope)
          
          // Check for updates every 5 minutes
          setInterval(() => {
            registration.update()
          }, 5 * 60 * 1000)
          
          // Handle updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing
            
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New service worker available, notify user
                  console.log('🔄 New version available! Updating...')
                  
                  // Automatically activate new service worker
                  newWorker.postMessage({ type: 'SKIP_WAITING' })
                  
                  // Show toast notification to user (optional)
                  showUpdateNotification()
                }
              })
            }
          })
        })
        .catch((error) => {
          console.error('❌ Service Worker registration failed:', error)
        })
      
      // Reload page when new service worker takes control
      let refreshing = false
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true
          console.log('🔄 New service worker activated, reloading page...')
          window.location.reload()
        }
      })
    })
  }
}

// Show update notification to user
function showUpdateNotification() {
  // Create a subtle toast notification
  const toast = document.createElement('div')
  toast.style.cssText = `
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #C8102E;
    color: white;
    padding: 16px 24px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 10000;
    font-family: system-ui, -apple-system, sans-serif;
    font-size: 14px;
    font-weight: 500;
    animation: slideIn 0.3s ease-out;
  `
  toast.textContent = '✨ Nova versão disponível! Atualizando...'
  document.body.appendChild(toast)
  
  // Add animation
  const style = document.createElement('style')
  style.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(400px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `
  document.head.appendChild(style)
  
  // Remove after 3 seconds
  setTimeout(() => {
    toast.style.animation = 'slideIn 0.3s ease-in reverse'
    setTimeout(() => toast.remove(), 300)
  }, 3000)
}

// Request notification permission
export async function requestNotificationPermission(): Promise<boolean> {
  if (!('Notification' in window)) {
    console.warn('This browser does not support notifications')
    return false
  }

  if (Notification.permission === 'granted') {
    return true
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission()
    return permission === 'granted'
  }

  return false
}

// Show local notification (fallback for push)
export function showLocalNotification(title: string, options?: NotificationOptions) {
  if (Notification.permission === 'granted') {
    new Notification(title, {
      icon: 'https://lumi.new/lumi.ing/logo.png',
      badge: 'https://lumi.new/lumi.ing/logo.png',
      vibrate: [200, 100, 200],
      ...options
    })
  }
}

// Check if app is installed (PWA or APK)
export function isAppInstalled(): boolean {
  return window.matchMedia('(display-mode: standalone)').matches ||
         (window.navigator as any).standalone === true ||
         document.referrer.includes('android-app://')
}

// Prompt user to install PWA
let deferredPrompt: any = null

export function setupInstallPrompt() {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt = e
    console.log('💡 PWA install prompt ready')
  })
}

export async function promptInstall(): Promise<boolean> {
  if (!deferredPrompt) {
    console.warn('Install prompt not available')
    return false
  }

  deferredPrompt.prompt()
  const { outcome } = await deferredPrompt.userChoice
  deferredPrompt = null
  
  return outcome === 'accepted'
}
